var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuggestionSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_165472)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8333 19.9167C39.8333 30.8974 30.8974 39.8053 19.9167 39.8053C8.90788 39.8053 0 30.8974 0 19.9167C0 8.90788 8.90788 0 19.9167 0C30.8974 0 39.8333 8.90788 39.8333 19.9167Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_421_165472",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 38,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1175 23.2726C39.1175 33.4186 30.8903 41.6458 20.7443 41.6458C10.5983 41.6458 2.37109 33.4186 2.37109 23.2726C2.37109 13.1266 10.5983 4.89941 20.7443 4.89941C30.8903 4.89941 39.1175 13.1266 39.1175 23.2726Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_421_165472)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7164 30.0013L39.5763 29.8612C39.5763 29.8612 39.567 29.8519 39.5483 29.8332L39.7444 29.6651L33.9459 23.8666C33.8618 23.5585 33.6938 23.2503 33.4417 22.9982L33.4136 22.9702C34.7862 20.4771 34.6742 17.3958 33.0495 15.0148V13.25H31.3968C28.6516 11.1771 24.8419 11.1771 22.1247 13.25H20.7241V14.6506C18.6232 17.3678 18.6232 21.2055 20.7241 23.9226V25.5753H22.4889C24.8419 27.172 27.8672 27.3121 30.3323 25.9955L30.3883 26.0516C30.6404 26.3037 30.9486 26.4717 31.2567 26.5558L37.0552 32.3543L37.2233 32.1862C37.242 32.1862 37.2513 32.1862 37.2513 32.1862L37.3914 32.3263C37.9796 32.9426 38.9881 32.9426 39.5763 32.3263L39.7164 32.1862C40.3327 31.598 40.3327 30.6175 39.7164 30.0013Z",
    fill: "#002173"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.546 46.6683L9.88415 46.6963L9.82812 17.3395L32.518 17.3115L32.546 46.6683Z",
    fill: "#002173"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.921 43.4188L8.23113 43.4748L8.20312 14.09L30.865 14.062L30.921 43.4188Z",
    fill: "#D3D3D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9874 45.3521L6.32556 45.3801L6.26953 16.0233L28.9594 15.9673L28.9874 45.3521Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4383 23.8941C26.4383 26.1071 24.6455 27.8999 22.4326 27.8999H13.3847C11.1717 27.8999 9.37891 26.1071 9.37891 23.8941C9.37891 21.6531 11.1717 19.8604 13.3847 19.8604H22.4326C24.6455 19.8604 26.4383 21.6531 26.4383 23.8941Z",
    fill: "#D3D3D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2874 33.9508H10.1328V31.2056H25.2874V33.9508Z",
    fill: "#D3D3D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2874 39.0767H10.1328V36.3315H25.2874V39.0767Z",
    fill: "#D3D3D3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5803 26.3869C14.2806 25.1543 14.6447 23.5576 15.0369 22.185C14.6634 22.185 14.2899 22.185 13.9164 22.185C14.6447 24.342 15.289 26.5549 16.0734 28.6839C16.2694 29.1601 17.0818 29.3001 17.1938 28.6839C17.7541 25.5185 18.4264 22.3811 19.0987 19.2438C18.7252 19.2438 18.361 19.2438 18.0062 19.2438C18.7065 22.6332 18.9866 26.0787 19.771 29.4402C19.883 29.8884 20.6393 30.0565 20.8354 29.5803C21.7038 27.4793 22.5442 25.3504 23.3005 23.1935C23.5526 22.5212 22.4601 22.2131 22.208 22.9134C21.4517 24.9582 20.6954 27.0031 19.827 28.992C20.1818 29.048 20.5366 29.0947 20.8915 29.1321C20.0791 25.7706 19.827 22.3251 19.0987 18.9636C18.9866 18.4034 18.1183 18.4034 18.0062 18.9636C17.3059 22.073 16.6336 25.2104 16.0734 28.3757C16.4469 28.3757 16.8203 28.3757 17.1938 28.3757C16.3815 26.2468 15.7372 24.0619 15.0369 21.8769C14.8408 21.3447 14.0845 21.3167 13.9164 21.8769C13.5803 23.1655 13.2441 24.6781 12.5718 25.8266C12.2077 26.4709 13.1881 27.0311 13.5803 26.3869Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_421_165472",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 13,
    height: 14
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0781 24.2026H33.3867V11.894H21.0781V24.2026Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_421_165472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7881 13.8942C34.1691 16.3032 34.1691 20.1969 31.7881 22.578C29.3791 24.987 25.4854 24.987 23.0763 22.578C20.6673 20.1969 20.6673 16.3032 23.0763 13.8942C25.4854 11.4851 29.3791 11.4851 31.7881 13.8942Z",
    fill: "#EAEAE9"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0523 28.6281C40.6685 29.2444 40.6685 30.2248 40.0523 30.8411L39.9122 30.9531C39.324 31.5694 38.3435 31.5694 37.7273 30.9531L37.5872 30.8411C36.9709 30.2248 36.9709 29.2444 37.5872 28.6281L37.7273 28.4881C38.3435 27.8998 39.324 27.8998 39.9122 28.4881L40.0523 28.6281Z",
    fill: "#C93831"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4595 12.5492C35.4288 15.5185 35.4288 20.3366 32.4595 23.3059C29.5183 26.2752 24.7002 26.2752 21.7309 23.3059C18.7616 20.3366 18.7616 15.5185 21.7309 12.5492C24.7002 9.57994 29.5183 9.57994 32.4595 12.5492ZM31.115 13.8938C28.902 11.6809 25.2884 11.6809 23.0755 13.8938C20.8625 16.1068 20.8625 19.7204 23.0755 21.9333C25.2884 24.1463 28.902 24.1463 31.115 21.9333C33.3279 19.7204 33.3279 16.1068 31.115 13.8938Z",
    fill: "#E74C3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0811 28.2923L37.3919 30.9815L31.1172 24.7067L33.8064 22.0176L40.0811 28.2923Z",
    fill: "#E74C3C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7779 21.6249C34.5902 22.4373 34.5902 23.7819 33.7779 24.5942L33.6938 24.6783C32.8815 25.4906 31.5369 25.4906 30.7246 24.6783L30.6405 24.5942C29.8282 23.7819 29.8282 22.4373 30.6405 21.6249L30.7246 21.5409C31.5369 20.7286 32.8815 20.7286 33.6938 21.5409L33.7779 21.6249Z",
    fill: "#C93831"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_165472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestionSelected);
export default __webpack_public_path__ + "static/media/suggestion-selected.58df96fc82bf70d94149954f38f4aca1.svg";
export { ForwardRef as ReactComponent };